$(document).ready(function () {
    if ($('#model_has_roles_table').length) {

        $('#model_has_roles_table').dataTable({
            'pageLength': 25,
            "language": {
                "url": "/json/Spanish.json"
            },
        });

        document.getElementById('add_model_has_roles').onclick = function () {
            $.ajax({
                url: window.location.origin + '/role/has/permissions/manager/create',
                type: 'GET',
            })
                .done(function (response) {
                    document.getElementById('div_modal_permissions').innerHTML = response;
                    $('.chosen-select').chosen({width: '100%'});
                    $('#modal-role-has-permissions').modal("show");
                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });
        }

        $(document).on('click', '#send_role_has_permissions', function (event) {
            const data = $("#formRoleHasPermissions").serialize();
            event.preventDefault();
            document.getElementById('div_message').innerHTML = "";
            $.ajax({
                data: data,
                url: window.location.origin + '/role/has/permissions/manager',
                type: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {
                    Swal.fire('Agregado', 'Se asigno el rol al permiso correctamente', 'success')
                        .then(() => {
                            $('#modal-role-has-permissions').modal("hide");
                            location.reload();
                        });
                })
                .fail(function (jqXHR, textStatus) {
                    //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                    if (jqXHR['status'] == 422) {

                        let errors = "<ul class=''>";
                        let items = "";

                        $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                            items = items + "<li class='' style='text-align:left'>" + value + "</li>";
                        });

                        errors = errors + items + "</ul>";
                        let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                            + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                            + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                            + errors
                            + "</div></div></div>";
                        document.getElementById('div_message').innerHTML = view;
                    } else {
                        console.log(jqXHR['status']);
                        alert("Disculpe, existió un problema");
                    }
                });
        });

        window.editPermissions = function (rol, permissions) {
            $.ajax({
                url: window.location.origin + '/role/has/permissions/manager/' + rol + '/' + permissions + '/edit',
                type: 'GET',
            })
                .done(function (response) {
                    document.getElementById('div_modal_permissions').innerHTML = response;
                    $('.chosen-select').chosen({width: '100%'});
                    $('#modal-role-has-permissions').modal("show");
                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });
        }

        window.deletePermissions = function (rol, permissions) {
            Swal
                .fire({
                    title: "Eliminar el rol asignado al permiso",
                    text: "¿Eliminar?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: "Sí, eliminar",
                    cancelButtonText: "Cancelar",
                })
                .then(resultado => {
                    if (resultado.value) {
                        $.ajax({
                            url: window.location.origin + '/role/has/permissions/manager/' + rol + '/' + permissions,
                            type: 'DELETE',
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            }
                        })
                            .done(function (response) {
                                Swal.fire('Eliminado', ' Se ha eliminado el rol asignado al permiso.', 'success')
                                    .then(() => {
                                        location.reload();
                                    });
                            })
                            .fail(function (jqXHR, textStatus) {
                                console.log(jqXHR);
                                alert("Disculpe, existió un problema");
                            });
                    }
                });
        }

        $(document).on('click', '#sent_role_has_permissions_update', function (event) {
            event.preventDefault();
            const data = $("#formRoleHasPermissions").serialize();
            let id = 0;
            document.getElementById('div_message').innerHTML = "";
            $.ajax({
                data: data,
                url: window.location.origin + '/role/has/permissions/manager/' + id,
                type: 'PUT',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {
                    Swal.fire('Actualizado', 'Se actualizo el rol al permiso correctamente', 'success')
                        .then(() => {
                            $('#modal-role-has-permissions').modal("hide");
                            location.reload();
                        });
                })
                .fail(function (jqXHR, textStatus) {
                    //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                    if (jqXHR['status'] == 422) {

                        let errors = "<ul class=''>";
                        let items = "";

                        $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                            items = items + "<li class='' style='text-align:left'>" + value + "</li>";
                        });

                        errors = errors + items + "</ul>";
                        let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                            + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                            + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                            + errors
                            + "</div></div></div>";
                        document.getElementById('div_message').innerHTML = view;
                    } else {
                        //console.log(jqXHR['status']);

                        console.log(jqXHR);
                        alert("Disculpe, existió un problema");
                    }
                });
        });

    }
});
